package com.xtream.data_kmp.db.tables

import androidx.room3.Entity
import androidx.room3.Index
import androidx.room3.PrimaryKey
import kotlin.time.Clock


/**
 * Sparse custom sort overrides. Only channels the user has manually reordered
 * get a row here. Everything else falls back to LiveStreamEntity.num at read time.
 *
 * position is a fractional key (e.g. 2.1, 2.2, 5.1) so new reorders can always
 * slot between two existing rows by computing a midpoint, without renumbering
 * anything else.
 */
@Entity(
    tableName = "live_stream_order",
    indices = [
        Index(value = ["streamId"], unique = true),
        Index(value = ["position"]),
         Index(value = ["categoryId"])

    ]
)
data class LiveStreamOrderEntity(
    @PrimaryKey(autoGenerate = true)
    val id: Long = 0,
    val streamId: Int,
    val position: Double,
    val categoryId: Int?,
    val updatedAt: Long = Clock.System.now().toEpochMilliseconds()
)